// extracted by mini-css-extract-plugin
export default {"root":"_3YA81Jdb","no-padding":"_2bi22KEb","noPadding":"_2bi22KEb","no-header":"_25BULrdo","noHeader":"_25BULrdo"};